import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-af240f20"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row-header" }
const _hoisted_2 = { class: "grade-number" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "grade-number-unit" }, "年", -1))
const _hoisted_4 = { class: "row-body" }
const _hoisted_5 = { class: "add-button-area" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ClassListTableRowItem = _resolveComponent("ClassListTableRowItem")!
  const _component_ClassListTableRowAddButton = _resolveComponent("ClassListTableRowAddButton")!

  return (_openBlock(), _createElementBlock("li", {
    class: _normalizeClass(["class-list-table-row-container", `theme${_ctx.theme}`]),
    style: _normalizeStyle(_ctx.styles)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.data.gradeNumber), 1),
      _hoisted_3
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_TransitionGroup, {
        class: "items",
        name: "items-group",
        tag: "ul"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.classes, (cls) => {
            return (_openBlock(), _createBlock(_component_ClassListTableRowItem, {
              key: cls.clientSideId,
              class: "item",
              "aria-label": "Class",
              height: _ctx.itemHeight,
              data: cls,
              editing: _ctx.editing,
              "on-input-name": (name) => _ctx.updateName(cls.clientSideId, name),
              "on-click-up": () => _ctx.moveClass(cls.clientSideId, true),
              "on-click-down": () => _ctx.moveClass(cls.clientSideId, false),
              "on-click-remove": () => _ctx.removeClass(cls.clientSideId)
            }, null, 8, ["height", "data", "editing", "on-input-name", "on-click-up", "on-click-down", "on-click-remove"]))
          }), 128))
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.editing)
          ? (_openBlock(), _createBlock(_component_ClassListTableRowAddButton, {
              key: 0,
              class: "add-button",
              "on-click": _ctx.addClass
            }, null, 8, ["on-click"]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 6))
}